export default function QuickConnectDevtool() {
  return null
}
